import apiWrapper from 'common/api/api-wrapper';
import { IAPIErrorContent } from 'common/api/type-def';

import {
	IControlDeDupTableResponse,
	IControlDeDupRunClusterResponse,
	ClusterResponse,
} from './type-def';

const { REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL } = process.env;

export const getControlDeDupTableData = async (params: any) => {
	let sortKey = '';
	if (params.sortKey) {
		sortKey = params?.sortKey === 'clusterId' ? 'clusterSize' : params?.sortKey;
	}
	const sortDirection = params?.sortDirection ? params?.sortDirection : '';
	const sortk = sortKey !== '' ? `${sortKey}` : '';
	const sortDir = sortDirection !== '' ? `${sortDirection}` : '';
	const resp = await apiWrapper.get<
		IControlDeDupTableResponse,
		IAPIErrorContent
	>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/control/cluster?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sortBy=${sortk}&sortOrderBy=${sortDir}`,
	);
	return resp;
};

export const getFeedingInventoryData = async () => {
	const resp = await apiWrapper.get<
		IControlDeDupRunClusterResponse,
		IAPIErrorContent
	>(`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/control/cluster/status`);
	return resp;
};

export const getClusterReviewData = async (data: any, id: string) => {
	let sortKey = '';
	if (data.sortKey) {
		sortKey = data?.sortKey === 'clustersId' ? 'controlId' : data?.sortKey;
	}
	const sortDirection = data?.sortDirection ? data?.sortDirection : '';
	const sortk = sortKey !== '' ? `${sortKey}` : '';
	const sortDir = sortDirection !== '' ? `${sortDirection}` : '';
	const resp = await apiWrapper.get<ClusterResponse, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/control/cluster/${id}?pageNumber=${data?.pageNumber}&pageSize=${data?.pageSize}&sortBy=${sortk}&sortOrderBy=${sortDir}`,
	);
	return resp;
};
